/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export interface CredentialsData {
  userName?: string;
  password?: string;
}

export class Credentials implements CredentialsData {
  readonly userName: string;
  readonly password: string;

  constructor(data: CredentialsData) {
    this.userName = data.userName;
    this.password = data.password;
  }
}
